import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ShowFormState {
  showForm: boolean;
}

const initialState: ShowFormState = {
  showForm: false,
};

export const showFormSlice = createSlice({
  name: "showForm",
  initialState,
  reducers: {
    setShowForm: (state, action: PayloadAction<boolean>) => {
      state.showForm = action.payload;
    },
  },
});

export const { setShowForm } = showFormSlice.actions;
